export default "__VITE_ASSET__zADAQMFK__"